import { Box, useTheme } from "@mui/material"
import { HalfPersonIcon, ShieldIcon } from "./IconUrls"

export const SecurityDialogIcon = ({ size = 56 }: { size?: number }) => {
  const theme = useTheme()
  return (
    <Box width={size} height={size} position="relative">
      <HalfPersonIcon size={size} color={theme.palette.primary.light1} />
      <ShieldIcon
        color={theme.palette.warning.light}
        size={Number.parseInt(size?.toString()) / 2}
        style={{
          position: "absolute",
          bottom: 0,
          right: -10,
        }}
      />
    </Box>
  )
}
